import ImageCircularAvatar from '@/components/UI/Avatar/ImageCircularAvatar';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/UI/Tooltip';
import { getInitials } from '@/utils';

interface AvatarGroupProps {
  items?: {
    image: string;
    name: string;
  }[];
}

export function AvatarGroup({ items = [] }: AvatarGroupProps) {
  return (
    <div className='flex -space-x-2 overflow-hidden'>
      {items.map((item, index) => (
        <Tooltip key={index}>
          <TooltipTrigger>
            <ImageCircularAvatar
              key={index}
              customClass='h-8 w-8 ring-2 ring-white font-medium'
              imageUrl={item.image}
              fallbackText={getInitials(item.name)}
            />
          </TooltipTrigger>
          <TooltipContent>{item.name}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
